<template>
  <div class="dy-org-management-container" :style="{width: width + 'px',height: height + 'px'}">
    <div style="display: flex;justify-content: space-between;align-items: center; margin-bottom: 10px;">
      <el-input
        v-model="queryForm.tableSearchVal"
        placeholder="请输入搜索条件"
        style="flex: 1;"
        @input="handleTableFilter"
      >
        <template v-slot:suffix>
          <el-button type="text" icon="el-icon-search" @click="handleTableFilter" />
        </template>
      </el-input>
      <el-button
        v-if="permissions.add && showTopAddBtn"
        icon="el-icon-plus"
        type="primary"
        size="mini"
        circle
        style="width: 28px;height: 28px;margin-left: 5px;"
        @click="handleAdd()"
      />
    </div>
    <el-table
      ref="tableRef"
      v-loading="loading"
      height="100%"
      :data="filterTableData"
      :row-key="rowKey"
      highlight-current-row
      :current-row-key="currentRowKey"
      default-expand-all
      border
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      @row-click="handleTableSelect"
    >
      <template v-for="(column, index) in tableColumns">
        <el-table-column
          v-if="!column.showInWidth || width > column.showInWidth"
          :key="index"
          :label="column.label"
          :min-width="column.width"
          show-overflow-tooltip
          :prop="column.prop"
          :column-key="column.prop"
        >
          <template #header>
            <div class="main-header">
              {{ column.label }}
              <i class="el-icon-refresh refresh-icon" color="#777666" @click="refresh" />
            </div>
          </template>
          <template #default="{row, $index}">
            <template v-if="column.mainColumn">
              <span>
                <DyTreeIcon
                  :type="column.mainColumnIcon && column.mainColumnIcon(row, $index)"
                  style="padding-top: 3px;"
                />
                <a class="normal_label">{{ column.formatter ? column.formatter(row, $index) : row.name }}</a>
                <div v-if="operateable" class="fr">
                  <el-dropdown trigger="click" @command="operateDropdown($event, row)">
                    <i class="el-icon-more" @click.stop />
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-hasPermi="permissions.add" icon="el-icon-plus" command="add">新增</el-dropdown-item>
                      <el-dropdown-item
                        v-if="!column.mainColumnEditable || column.mainColumnEditable(row)"
                        v-hasPermi="permissions.edit"
                        icon="el-icon-edit"
                        command="edit"
                      >编辑</el-dropdown-item>
                      <el-dropdown-item
                        v-if="!column.mainColumnDelable || column.mainColumnDelable(row)"
                        v-hasPermi="permissions.del"
                        icon="el-icon-delete"
                        command="del"
                      >删除</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </span>
            </template>
            <template v-else>
              <span v-if="column.formatter">{{ column.formatter(row, $index) }}</span>
              <span v-else-if="column.dicUrl">{{ getColumnValueByDic(column, row, $index) }}</span>
              <span v-else>{{ row[column.prop] }}</span>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DyOrgManagement',
  props: {
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    permissions: {
      type: Object,
      default: () => ({})
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    dataPath: {
      type: String,
      default: 'data.data'
    },
    confirmDeleteTitle: {
      type: String,
      default: '删除'
    },
    confirmDeleteContent: {
      type: String,
      default: '确认删除'
    },
    tableListApi: {
      type: Function
    },
    tableDeleteApi: {
      type: Function
    },
    showTopAddBtn: {
      type: Boolean,
      default: false
    },
    defaultSelect: {
      type: Boolean,
      default: true
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    allowClear: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['organizationId']),
    project() {
      return {
        id: this.organizationId
      }
    },
    operateable() {
      return this.permissions.add || this.permissions.edit || this.permissions.del
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentSelected: undefined,
      filterTableData: [],
      defaultExpandAll: true,
      dictionary: {},
      currentRowKey: undefined,
      queryForm: {
        tableSearchVal: undefined,
        projectCode: undefined,
        selectedTableRowId: undefined
      },
      projectTreeData: [],
      treeProps: {
        children: 'children',
        label: 'name'
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      await this.loadDictionary()
      this.refresh()
    },
    async refresh() {
      try {
        this.loading = true
        console.log('this.tableListApi: ', this.tableListApi)
        const res = await this.tableListApi()
        /* eslint-disable-next-line */
        const tableData = eval(res[this.dataPath]) || []
        this.tableData = tableData
        if (this.defaultSelect && tableData[0]) {
          this.$emit('defaultSelected', tableData[0])
          this.currentRowKey = tableData[0][this.rowKey]
          console.log('this.currentRowKey: ', this.currentRowKey)
        }
        this.filterTableData = JSON.parse(JSON.stringify(tableData))
      } finally {
        setTimeout(() => {
          this.loading = false
        }, 200)
      }
    },
    async loadDictionary() {
      for (let i = 0; i < this.tableColumns.length; i++) {
        const column = this.tableColumns[i]
        const { dicCode, dicUrl } = column
        if (!dicUrl) continue
        dicUrl({ dicCode: dicCode }).then(res => {
          this.dictionary[dicCode] = res.data.data.reduce((obj, item) => {
            obj[item.value] = item.label
            return obj
          }, {})
        })
      }
    },
    handleTableSelect(row) {
      console.log(this.currentSelected && row[this.rowKey] === this.currentSelected[this.rowKey])
      this.tableData = JSON.parse(JSON.stringify(this.filterTableData))
      if (!row) return
      if (this.allowClear && this.currentSelected && row[this.rowKey] === this.currentSelected[this.rowKey] && this.defaultSelect && this.tableData[0]) {
        this.$emit('defaultSelected', this.tableData[0])
        setTimeout(() => {
          this.currentRowKey = this.tableData[0][this.rowKey]
          this.$refs.tableRef.setCurrentRow(this.filterTableData[0])
          this.currentSelected = this.tableData[0]
        })
        return
      }
      this.currentSelected = row
      this.$emit('onchange', row)
    },
    handleTableFilter() {
      if (this.interval) {
        clearTimeout(this.interval)
      }
      this.interval = setTimeout(() => {
        const res = JSON.parse(JSON.stringify(this.tableData))
        if (this.queryForm.tableSearchVal) {
          this.tableFilterSearch(res)
        }
        this.filterTableData = res
      }, 500)
    },
    tableFilterSearch(arr) {
      const filter = arr.filter(item => {
        if (item.children) {
          this.tableFilterSearch(item.children)
        }
        return item.name.includes(this.queryForm.tableSearchVal) || (item.children && item.children.length)
      })
      arr.splice(0, arr.length, ...filter)
    },
    handleFold() {
      this.defaultExpandAll = !this.defaultExpandAll
      // table折叠
      const ref = this.$refs.tableRef
      this.folder(ref, this.filterTableData, this.defaultExpandAll)

      // tree折叠
      // for(let j=0; j<this.$refs.tableRef.store._getAllNodes().length; j++){
      //   this.$refs.tableRef.store._getAllNodes()[j].expanded= this.defaultExpandAll
      // }
    },
    folder(ref, data, isFold) {
      data.forEach(item => {
        ref.toggleRowExpansion(item, isFold)
        if (data.children && data.children.length) {
          this.folder(ref, item.children, isFold)
        }
      })
    },
    handleEdit(row) {
      this.$emit('onedit', {
        row: row,
        resolve: () => {
          this.refresh()
        }
      })
    },
    handleDelete(row) {
      this.$confirm(
        this.confirmDeleteContent,
        this.confirmDeleteTitle,
        {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(async() => {
        if (this.tableDeleteApi) {
          await this.tableDeleteApi(row[this.rowKey])
          this.$message.success('删除成功')
          this.refresh()
        } else {
          this.$emit('ondelete', {
            row: row,
            resolve: this.refresh
          })
        }
      })
    },
    handleAdd(row) {
      this.$emit('onadd', {
        row,
        resolve: () => {
          this.refresh()
        }
      })
    },
    getColumnValueByDic(column, row) {
      const { dicCode } = column
      if (this.dictionary[dicCode]) {
        return this.dictionary[dicCode][row[column.prop]]
      } else {
        return row[column.prop]
      }
    },
    operateDropdown(event, row) {
      switch (event) {
        case 'add':
          this.handleAdd(row)
          break
        case 'edit':
          this.handleEdit(JSON.parse(JSON.stringify(row)))
          break
        case 'del':
          this.handleDelete(JSON.parse(JSON.stringify(row)))
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dy-org-management-container {
  box-sizing: border-box;
  background: white;
  height: 100%;
  padding: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;

  .tree_label {
    color: #1890ff !important;
    text-decoration: underline !important;
    font-weight: bold;
    cursor: pointer;
    margin-left: 2px;
  }

  .normal_label {
    margin-left: 2px;
  }

  // ::v-deep .el-table__expand-icon {
  //   margin-right: 2px !important;
  // }

  .main-header {
    position: relative;

    .refresh-icon {
      cursor: pointer;
      z-index: 2;
      position: absolute;
      top: 4px;
      right: 0px;
    }
  }
}
</style>
